import React from 'react';
import { DashboardProvider } from './contexts/DashboardContext';
import { AuthProvider } from './contexts/AuthContext';
import { VideoPlayerProvider } from './components/VideoPlayerModule';
import DashboardLayout from './components/layout/DashboardLayout';

function App() {
  return (
    <AuthProvider>
      <DashboardProvider>
        <VideoPlayerProvider>
          <div className="h-screen">
            <DashboardLayout />
          </div>
        </VideoPlayerProvider>
      </DashboardProvider>
    </AuthProvider>
  );
}

export default App;
